import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Scroller from 'ui-component/Scroller';
import InvoiceModal from './components/modals/InvoiceModal';

import ShipmentTrackingModal from 'ui-component/confirmation-dialogs/awbModal/ShipmentTrackingModal';
import PrivacyModeContent from 'ui-component/PrivacyModeContent';
import ActionConfirmationModal from 'ui-component/confirmation-dialogs/actionConfirmationModal/ActionConfirmationModal';
import { PiInfoFill, PiWarningFill } from 'react-icons/pi';

import usePageTitle from 'hooks/usePageTitle';
import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';
import { FaPlus } from 'react-icons/fa';
import ReturnsDetailsComponent from './components/ReturnsDetailsComponent';
import ReturnsHistoryComponent from './components/ReturnsHistoryComponent';
import ReturnsReturnedProductsComponent from './components/ReturnsReturnedProductsComponent';
import ReturnsReplacementComponent from './components/ReturnsReplacementComponent';
import InvoiceModalProduct from './components/modals/InvoiceModalProduct';
import StatusBadge from 'ui-component/StatusBadge';


// ✅ Clear
function ReturnsDetails({ edit }) {
	const [setPageTitle] = usePageTitle('Returns');
	useEffect(() => {
		return () => {
			setPageTitle(null);
		};
	}, []);
	const { id } = useParams();
	const history = useNavigate();
	const [shippingCompanies, setShippingCompanies] = useState();
	const [disableProductBtn, setDisableProductBtn] = useState(true);
	const [showTrackingNoModal, setShowTrackingNoModal] = useState(false);
	const [invoiceProduct, setInvoiceProduct] = useState(false);
	const [invoiceDetails, setInvoiceDetails] = useState({
		estimationId: '',
		invoiceNumber: '',
		customerId: '',
		customerName: '',
		vatNumber: '',
		registrationNumber: '',
		billingAddress: '',
		billingZipcode: '',
		billingCity: '',
		billingCountry: '',
		shippingAddress: '',
		shippingZipcode: '',
		shippingCity: '',
		shippingCountry: ''
	});

	const [openPopup, setOpenPopup] = useState(false);

	const handleSelectInvoice = (type) => {
		setOpenPopup(type);
	};
	const closePopup = () => {
		setOpenPopup(false);
		setInvoiceProduct(false);
	};
	const [errorDialog, setErrorDialog] = useState({
		show: false,
		message: '',
		title: ''
	});

	const handleSave = (data) => {
		handleSetEstimationId(data?.estimationId);

		api.getInvoiceNumberCustomer(data?.estimationId).then((res) => {
			setInvoiceDetails({
				estimationId: res.data?.id,
				invoiceNumber: res.data?.invoice_number,
				customerId: res.data?.customer?.id,
				customerName: res.data?.customer?.name,
				vatNumber: res.data?.customer?.vat_number,
				registrationNumber: res.data?.customer?.registration_number,
				billingAddress: res.data?.customer?.billing_address?.address,
				billingZipcode: res.data?.customer?.billing_address?.zipcode,
				billingCity: res.data?.customer?.billing_address?.city,
				billingCountry: res.data?.customer?.billing_address?.country,
				shippingAddress: res.data?.customer?.shipping_address?.address,
				shippingZipcode: res.data?.customer?.shipping_address?.zipcode,
				shippingCity: res.data?.customer?.shipping_address?.city,
				shippingCountry: res.data?.customer?.shipping_address?.country
			});
			setReturnsDetail({
				estimationId: res.data?.id,
				invoiceNumber: res.data?.invoice_number,
				customerName: res.data?.customer_name
			});
		});

		if (returnsDetail?.id) {
			api
				.updateReturnsEstimateDetails(returnsDetail?.id, {
					estimation_id: data?.estimationId
				})
				.then((res) => {});
		}
		setOpenPopup(false);
	};

	const [returnsDetail, setReturnsDetail] = useState({
		id: '',
		referenceNo: '',
		estimationId: '',
		is_approved: '',
		invoiceNumber: '',
		customerId: '',
		customerName: '',
		vatNumber: '',
		registrationNumber: '',
		billingAddress: '',
		billingZipcode: '',
		billingCity: '',
		billingCountry: '',
		shippingAddress: '',
		shippingZipcode: '',
		shippingCity: '',
		shippingCountry: '',
		totalReturns: 0,
		totalReplacements: 0,
		returns: [],
		replacements: [],
		histories: [],
		returnValue: 0,
		replacementValue: 0,
		repairValue: 0,
		differenceValue: 0
	});

	const getShipmentInvoiceDetails = (callback = () => {}) => {
		api.getShipmentDetails(id).then((res) => {
			if (res?.status) {
				callback(res.data);
			} else {
				history('/returns');
			}
		});
	};
	const getReturnsDetails = (callback = () => {}) => {
		api.getReturnsDetails(id).then((res) => {
			if (res?.status) {

				setInvoiceDetails({
					estimationId: res.data?.estimation?.id,
					invoiceNumber: res.data?.estimation?.invoice_number,
					customerId: res.data?.customer?.id,
					customerName: res.data?.customer?.name,
					vatNumber: '',
					registrationNumber: '',
					billingAddress: res.data?.customer?.billing_address?.address,
					billingZipcode: res.data?.customer?.billing_address?.zipcode,
					billingCity: res.data?.customer?.billing_address?.city,
					billingCountry: res.data?.customer?.billing_address?.country,
					shippingAddress: res.data?.customer?.shipping_address?.address,
					shippingZipcode: res.data?.customer?.shipping_address?.zipcode,
					shippingCity: res.data?.customer?.shipping_address?.city,
					shippingCountry: res.data?.customer?.shipping_address?.country
				});
				setReturnsDetail({
					...res.data,
					id: res.data?.id,
					referenceNo: res.data?.reference_no,
					estimationId: res.data?.estimation?.id,
					is_approved: res.data?.is_approved,
					invoiceNumber: res.data?.estimation?.invoice_number,
					statusId: res.data?.status?.id,
					status: res.data?.status?.name,
					customerName: res.data?.customer?.name,
					totalReturns: res.data?.returns?.length,
					totalReplacements: res.data?.replacements?.length,
					returns: res.data?.returns,
					replacements: res.data?.replacements,
					histories: res.data?.histories,
					returnValue: res.data?.returning_value,
					replacementValue: res.data?.replacement_value,
					repairValue: res.data?.repair_value,
					differenceValue: res.data?.difference_value,
					currency: res.data?.estimation?.currency
				});
				callback(res.data);
			} else {
				history('/returns');
			}
		});
	};

	const handleCloseErrorDialog = () => {
		setErrorDialog({
			show: false,
			message: '',
			title: ''
		});
	};

	const handleFormSubmit = (e) => {
		toast.promise(
			api
				.updateShipmentAwb(id, {
					tracking_no: e?.trackingNo,
					shipping_company_id: e?.shippingCompanyId,
					shipment_id: showTrackingNoModal
				})
				.then((res) => {
					if (res.status) {
						getShipmentInvoiceDetails();
						handleCloseShipmentTrackingModal();
					}
				}),
			{
				loading: 'Updating Tracking...',
				success: <b>Tracking Detail updated!</b>,
				error: <b>Could not Update Tracking Detail.</b>
			}
		);
	};

	const handleSetEstimationId = (value) => {
		setReturnsDetail({
			...returnsDetail,
			estimationId: value
		});
		setDisableProductBtn(false);
	};
	const handleSetReplacements = (value) => {
		setReturnsDetail({
			...returnsDetail,
			replacements: value
		});
	};

	const newReturnedDetails = (data) => {
		setReturnsDetail({
			...returnsDetail,
			returns: data
		});
	};
	const handleSetImeis = (value) => {
		setReturnsDetail({
			...returnsDetail,
			returns: value
		});
	};

	const handleSelectInvoiceProduct = () => {
		setInvoiceProduct(true);
	};

	const handleLoadRecord = (value) => {
		getReturnsDetails();
	};

	const showErrorDialog = (title, message = '') => {
		setErrorDialog({
			show: true,
			message: message,
			title: title
		});
	};

	const handleSubmit = () => {
		if (edit && id) {
			return false;
		} else {
			if (!returnsDetail?.estimationId || returnsDetail?.estimationId == '') {
				showErrorDialog('Invalid Invoice', `Please Select Invoice`);
				return;
			}
			if (returnsDetail?.returns.length == 0) {
				showErrorDialog('Invalid Product', `Please add returning products`);
				return;
			}
			toast.promise(
				api
					.getCreateReturns({
						estimation_id: returnsDetail?.estimationId,
						replacements: returnsDetail?.replacements,
						returns: returnsDetail?.returns
					})
					.then((res) => {
						if (res?.status) {
							history(`/returns`);
							// history(`/returns/${res?.data?.returns_id}`);
						}
					}),
				{
					loading: 'Creating Returns...',
					success: <b>Returns Created!</b>,
					error: <b>Could not Create Returns.</b>
				}
			);
		}
	};

	const [confirmationDialog, setConfirmationDialog] = useState({
		show: false,
		message: '',
		title: '',
		handleConfirm: () => {},
		handleClose: () => {}
	});


	useEffect(() => {
		if (id) {
			setDisableProductBtn(false);
			getReturnsDetails();
		}
	}, []);


	const handleCloseShipmentTrackingModal = (data) => {
		setShowTrackingNoModal('');
	};
	const redirectFunc = (data) => {
		setTimeout(() => {
			history(`/returns/${id}`);
		}, 1000);
	};

	return (
		<>
			<div className={`TaskDetails`}>
				<div className="row">
					<div className="col-12">
						<div className="row pb10">
							<div className="col-9">
								<div className="section-head" style={{ paddingTop: '0px', display: 'flex', justifyContent: 'space-between' }}>
									<h2 style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '18px' }}>
										<span style={{ whiteSpace: 'nowrap', fontSize: 18 }}>{returnsDetail?.referenceNo}</span>
									</h2>
									<div>
										<StatusBadge itemStatus={returnsDetail?.status === 'For Approval' ? 'Pending' : returnsDetail?.status} />{' '}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-9 col-6">
						<div className="row">
							<div className="col-12 mb20">
								<div className="card card-shadow p-2 card-box-shadow">
									<div className="row inbounding-imeis">
										<div className="col-xl-12 col-lg-12">
											<div className="row">
												<div className="col-12">
													<div className="d-flex align-items-center justify-content-between TableSerachBar">
														<div className="font18">
															<span className={invoiceDetails?.invoiceNumber ? 'returns-section-header' : 'returns-section-header gray'}>
																Invoices
															</span>
															{invoiceDetails?.invoiceNumber && (
																<>
																	:{' '}
																	<span className="font18" style={{ fontWeight: '600' }}>
																		<Link to={`/sales/invoices/${invoiceDetails?.estimationId}`}>
																			<PrivacyModeContent>{invoiceDetails?.invoiceNumber}</PrivacyModeContent>
																		</Link>
																	</span>
																</>
															)}
														</div>
														<div className="form-inline navbar-search">
															{invoiceDetails?.estimationId ? (
																<div className="row">
																	<div className="col-12">
																		<span
																			className="text-primary"
																			style={{ marginLeft: '20px', cursor: 'pointer' }}
																			onClick={() => {
																				handleSelectInvoice('Invoice');
																			}}
																		>
																			Edit &nbsp;
																			<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 19.875 21.722">
																				<g id="Group_40056" data-name="Group 40056" transform="translate(-2.982 -1.847)">
																					<path
																						id="Vector"
																						d="M14.452,1.27c2.195,2.076,1.559,3.774.149,5.263l-8.153,8.63a2.851,2.851,0,0,1-1.38.745l-3.2.546A1.517,1.517,0,0,1,.013,14.7l.367-3.218a3.029,3.029,0,0,1,.665-1.42L9.2,1.429c1.41-1.49,3.069-2.215,5.253-.159Z"
																						transform="translate(4.972 2.868)"
																						fill="none"
																						stroke="#06f"
																						strokeLinecap="round"
																						strokeLinejoin="round"
																						strokeWidth="2"
																					/>
																					<path
																						id="Vector-2"
																						data-name="Vector"
																						d="M5.412,5.114A6.084,6.084,0,0,1,0,0"
																						transform="translate(12.81 5.737)"
																						fill="none"
																						stroke="#06f"
																						strokeLinecap="round"
																						strokeLinejoin="round"
																						strokeWidth="2"
																					/>
																					<path
																						id="Vector-3"
																						data-name="Vector"
																						d="M0,0H17.875"
																						transform="translate(3.982 22.569)"
																						fill="none"
																						stroke="#06f"
																						strokeLinecap="round"
																						strokeLinejoin="round"
																						strokeWidth="2"
																					/>
																				</g>
																			</svg>
																		</span>
																	</div>
																</div>
															) : (
																<>
																	<button
																		className="bulk-action btn-outlined-main"
																		style={{ marginRight: 10 }}
																		onClick={() => {
																			handleSelectInvoice('Invoice');
																		}}
																	>
																		<FaPlus style={{ fontSize: '10px' }} /> Search Invoice
																	</button>
																	<button
																		className="bulk-action btn-outlined-main"
																		onClick={() => {
																			handleSelectInvoiceProduct();
																		}}
																	>
																		<FaPlus style={{ fontSize: '10px' }} /> Search Product
																	</button>
																</>
															)}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-12 mb20">
								<ReturnsReturnedProductsComponent
									returnsDetail={returnsDetail}
									disableProductBtn={disableProductBtn}
									handleSetImeis={handleSetImeis}
									handleLoadRecord={handleLoadRecord}
									newReturnedDetails={newReturnedDetails}
									id={id}
								/>
							</div>
							<div className="col-12 mb20">
								<ReturnsReplacementComponent
									returnsDetail={returnsDetail}
									disableProductBtn={disableProductBtn}
									handleSetReplacements={handleSetReplacements}
									handleLoadRecord={handleLoadRecord}
								/>
							</div>

							<div className="col-12 text-center" style={{ display: 'flex', justifyContent: 'center' }}>
								{!edit && (
									<PermissionAllowed permissions={['Create Returns (Button)']}>
										<button className="bulk-action btn-outlined-main ml8" onClick={() => handleSubmit()}>
											<FaPlus /> Save
										</button>
									</PermissionAllowed>
								)}
							</div>
						</div>
					</div>
					<div className="col-md-3 col-6">
						<ReturnsDetailsComponent
							returnsDetail={returnsDetail}
							// disableProductBtn={disableProductBtn}
							handleSetEstimationId={handleSetEstimationId}
							invoiceDetails={invoiceDetails}
						/>

						{edit && (
							<>
								<div className="row">
									<div className="col-12">
										<div className="card card-shadow p-2">
											<Scroller>
												<div className="row inbounding-imeis">
													<div className="col-xl-12 col-lg-12">
														<div className="row">
															<div className="col-12">
																<div className="d-flex align-items-center justify-content-between TableSerachBar">
																	<div className="font14">Totals</div>
																</div>
															</div>
														</div>
														<div className="row">
															<div className="col-12" style={{ margin: 'auto 10px' }}>
																<div className="row" style={{ marginBottom: '5px' }}>
																	<div className="col-5 font14 fw400 textGray">Returning</div>
																	<div className="col-7 font14">{returnsDetail?.totalReturns} products</div>
																</div>
																<div className="row" style={{ marginBottom: '5px' }}>
																	<div className="col-5 font14 fw400 textGray">Replacing</div>
																	<div className="col-7 font14">{returnsDetail?.totalReplacements} products</div>
																</div>
																<div className="row" style={{ marginBottom: '5px' }}>
																	<div className="col-5 font14 fw400 textGray">Value Returning</div>
																	<div className="col-7 font14">
																		{returnsDetail?.currency == 'eur'
																			? `€ ${returnsDetail?.returnValue}`
																			: returnsDetail?.currency == 'usd'
																			? `$ ${returnsDetail?.returnValue}`
																			: returnsDetail?.currency == 'aed'
																			? `د.إ ${returnsDetail?.returnValue}`
																			: `${returnsDetail?.currency} ${returnsDetail?.returnValue}`}
																	</div>
																</div>
																<div className="row" style={{ marginBottom: '5px' }}>
																	<div className="col-5 font14 fw400 textGray">Value Replacing</div>
																	<div className="col-7 font14">
																		{returnsDetail?.currency == 'eur'
																			? `€ ${returnsDetail?.replacementValue}`
																			: returnsDetail?.currency == 'usd'
																			? `$ ${returnsDetail?.replacementValue}`
																			: returnsDetail?.currency == 'aed'
																			? `د.إ ${returnsDetail?.replacementValue}`
																			: `${returnsDetail?.currency} ${returnsDetail?.replacementValue}`}
																	</div>
																</div>
																<div className="row" style={{ marginBottom: '5px' }}>
																	<div className="col-5 font14 fw400 textGray">Value Difference</div>
																	<div className="col-7 font14">
																		{returnsDetail?.currency == 'eur'
																			? `€ ${returnsDetail?.differenceValue}`
																			: returnsDetail?.currency == 'usd'
																			? `$ ${returnsDetail?.differenceValue}`
																			: returnsDetail?.currency == 'aed'
																			? `د.إ ${returnsDetail?.differenceValue}`
																			: `${returnsDetail?.currency} ${returnsDetail?.differenceValue}`}
																	</div>
																</div>
																<div className="row">
																	<div className="col-5 font14 fw400 textGray">Total Repair Cost</div>
																	<div className="col-7 font14">
																		{returnsDetail?.currency == 'eur'
																			? `€ ${returnsDetail?.repairValue}`
																			: returnsDetail?.currency == 'usd'
																			? `$ ${returnsDetail?.repairValue}`
																			: returnsDetail?.currency == 'aed'
																			? `د.إ ${returnsDetail?.repairValue}`
																			: `${returnsDetail?.currency} ${returnsDetail?.repairValue}`}
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</Scroller>
										</div>
									</div>
								</div>

								<div style={{ marginTop: '20px' }}>
									<ReturnsHistoryComponent returnsDetail={returnsDetail} handleLoadRecord={handleLoadRecord} />
								</div>
							</>
						)}
					</div>
				</div>
			</div>
			{showTrackingNoModal && (
				<ShipmentTrackingModal
					shipmentId={showTrackingNoModal}
					shippingCompanies={shippingCompanies}
					redirectionData={redirectFunc}
					onFormSubmit={handleFormSubmit}
					handleCloseShipmentTrackingModal={handleCloseShipmentTrackingModal}
				/>
			)}
			{confirmationDialog?.show && (
				<ActionConfirmationModal
					show={confirmationDialog?.show}
					message={confirmationDialog?.message}
					title={confirmationDialog?.title}
					customConfirmText={confirmationDialog?.customConfirm || 'Confirm'}
					customCancelText={confirmationDialog?.customCancel || 'Cancel'}
					customIcon={<PiInfoFill />}
					handleConfirm={confirmationDialog?.handleConfirm}
					handleClose={confirmationDialog?.handleClose}
				/>
			)}

			{errorDialog?.show && (
				<ActionConfirmationModal
					show={errorDialog?.show}
					message={errorDialog?.message}
					title={errorDialog?.title}
					noCancel
					customConfirmText="Okay"
					customIcon={<PiWarningFill />}
					handleConfirm={() => {
						handleCloseErrorDialog();
					}}
					handleClose={() => {
						handleCloseErrorDialog();
					}}
				/>
			)}
			{openPopup && (
				<InvoiceModal
					openPopup={openPopup}
					returnsDetail={returnsDetail}
					handleClose={closePopup}
					handleSave={handleSave}
					disableStatus={false}
				/>
			)}
			{invoiceProduct && (
				<InvoiceModalProduct
					openPopup={invoiceProduct}
					returnsDetail={returnsDetail}
					handleClose={closePopup}
					handleSave={handleSave}
					disableStatus={false}
				/>
			)}
		</>
	);
}

export default ReturnsDetails;
